var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6924 7.00053H3.55556C3.24873 7.00053 3 7.22439 3 7.50053C3 7.77667 3.24873 8.00053 3.55556 8.00053H11.6924L7.59619 12.0967C7.40093 12.292 7.40093 12.6086 7.59619 12.8038C7.79146 12.9991 8.10804 12.9991 8.3033 12.8038L12.5459 8.56119C12.8041 8.30299 12.9485 7.97408 12.9791 7.6368C12.9927 7.59348 13 7.54777 13 7.50053C13 7.45329 12.9927 7.40758 12.9791 7.36426C12.9485 7.02697 12.8041 6.69807 12.5459 6.43987L8.3033 2.19723C8.10804 2.00197 7.79146 2.00197 7.59619 2.19723C7.40093 2.39249 7.40093 2.70907 7.59619 2.90433L11.6924 7.00053Z",
    fill: "#343741"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarRightArrow);
export default __webpack_public_path__ + "static/media/CalendarRightArrow.99893bcac7ef2bc452fa2346121fb856.svg";
export { ForwardRef as ReactComponent };